import { createElement } from 'react';
import { InvisibleTextProps } from '.';

import cx from 'classnames';
import cn from './InvisibleText.css.json';
import './InvisibleText.css';

export const InvisibleText = (props: InvisibleTextProps) => {
  const { children, srOnly, testId, ...spanProps } = props;

  return (
    <span
      data-testid={testId}
      hidden={!srOnly}
      {...spanProps}
      className={cx(srOnly && cn.srOnly, spanProps.className)}
    >
      {children}
    </span>
  );
};
